import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { AuthScreen } from "../auth/AuthScreen";
import { localizedMessage, type LocalizedMessage } from "../../lib/app-status-policy";

export function MaintenanceScreen({ message }: { message?: LocalizedMessage }) {
  const { t, i18n } = useTranslation();
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    heading.current?.focus();
  }, []);
  return (
    <AuthScreen>
      <h1 ref={heading} tabIndex={-1} className="font-heading text-2xl font-bold">
        {t("home.maintenanceTitle")}
      </h1>
      <p className="mt-2 leading-normal break-words whitespace-pre-wrap text-muted-foreground">
        {localizedMessage(message, i18n.resolvedLanguage || i18n.language) ||
          t("home.maintenanceBody")}
      </p>
    </AuthScreen>
  );
}
